import { useState } from 'react'

const useToggle = () => {
  const [isOpen, setIsOpen] = useState(false)

  return {
    isOpen,
    onOpen: () => setIsOpen(true),
    onClose: () => setIsOpen(false),
    onToggle: () => setIsOpen((v) => !v)
  }
}

export default useToggle
